module.exports = ".btn{\r\n  padding: 5px 10px;\r\n  cursor:pointer;\r\n}\r\n"